import React, { useState } from "react";
import { useQuery } from "@apollo/client/react";
import { useNavigate, useLocation } from "react-router";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import CropFreeIcon from "@mui/icons-material/CropFree";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";

import useNotification from "../../hooks/notification";
import { ASSET_BY_BARCODE_QUERY } from "../../constants/graphql";
import BigButton from "../BigButton";
import ActionModal from "../modals/action-modal";
import ScanditScanner from "./ScanditScanner/ScanditScanner";

export default function LookupScanner({ onClose, clientId, projectId }) {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { notifyError } = useNotification();
  const { refetch } = useQuery(ASSET_BY_BARCODE_QUERY, {
    skip: true,
  });

  const handleToggle = () => setOpen(v => !v);

  const handleScan = barcode => {
    refetch({
      barcode,
      projectId,
      clientId,
    })
      .then(data => {
        if (data?.data?.asset) {
          onClose();
          navigate(`${pathname}/${data?.data?.asset.id}?order=asc&sort=id`);
        }
      })
      .catch(() => {
        notifyError(`Barcode ${barcode} not found`);
        handleToggle();
        handleToggle();
      });
  };

  const handleSubmit = e => {
    if (values.barcode && e.key === "Enter") {
      handleScan(values.barcode);
    }
  };

  const handleChange = e => {
    e.target.name === "location"
      ? setValues({
          ...initialValues,
          [e.target.name]: e.target.value,
        })
      : setValues({
          ...values,
          [e.target.name]: e.target.value,
        });
  };

  if (open) {
    return <ScanditScanner onDetected={handleScan} onClose={onClose} />;
  }

  return (
    <ActionModal
      open
      id="project"
      title="Lookup Scanner"
      maxWidth={440}
      onClose={onClose}
      disableTransition
    >
      <Box pt={1.5}>
        <BigButton onClick={handleToggle}>
          <CropFreeIcon fontSize="large" />
        </BigButton>

        <Box mb={1.5} />

        <FormControl fullWidth>
          <TextField
            name="barcode"
            label="Barcode"
            inputProps={{
              autoComplete: "off",
            }}
            value={values.barcode || ""}
            onChange={handleChange}
            onKeyPress={handleSubmit}
            variant="outlined"
          />
        </FormControl>
      </Box>
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button key="override" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </Box>
    </ActionModal>
  );
}
